import { render, staticRenderFns } from "./capita.vue?vue&type=template&id=49414fde"
import script from "./capita.vue?vue&type=script&lang=js"
export * from "./capita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports